// New screenings carry a separate name-only assessment. The provider score is
// retained for retrieval/order and for interpreting previously saved screenings.
export function pepNameStrength(result) {
  const strength = result?.nameAssessment?.strength;
  if (['strong', 'moderate', 'weak'].includes(strength)) return strength;
  const score = Number(result?.score);
  return score >= 0.9 ? 'strong' : score >= 0.75 ? 'moderate' : 'weak';
}
export function pepNameScore(result) {
  const score = Number(result?.nameAssessment?.score ?? result?.score);
  return Number.isFinite(score) ? score : null;
}
export function pepNameReason(result, displayedName = '') {
  const assessment = result?.nameAssessment;
  const reason = String(assessment?.matchReason || '').trim();
  const comparedName = String(assessment?.matchedName || '').trim();
  const displayKey = value => String(value || '').normalize('NFC').toLowerCase().replace(/\s+/g, ' ').trim();
  // The provider's caption can differ from the source variant actually scored.
  // Make formatting differences visible without changing the name assessment.
  if (reason && assessment?.matchType === 'normalized' &&
      assessment?.matchedNameKind !== 'alias' && comparedName && displayedName &&
      displayKey(comparedName) !== displayKey(displayedName)) {
    return `${reason} · Compared name: ${comparedName}`;
  }
  return reason;
}
